var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "admin-companies-autocomplete",
      staticStyle: { "z-index": "999" },
    },
    [
      _c("b-form-input", {
        staticClass: "admin-companies-autocomplete-input",
        attrs: { placeholder: _vm.placeholder, autocomplete: "off" },
        on: { input: _vm.onChangeInput },
        model: {
          value: _vm.search,
          callback: function ($$v) {
            _vm.search = $$v
          },
          expression: "search",
        },
      }),
      _vm._v(" "),
      _vm.company
        ? _c("b-icon", {
            staticClass: "admin-companies-autocomplete-clear cursor-pointer",
            attrs: { icon: "x" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return (() => _vm.setCompany()).apply(null, arguments)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.companies.length
        ? _c(
            "ul",
            { staticClass: "admin-companies-autocomplete-list" },
            _vm._l(_vm.companies, function (company, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "admin-companies-autocomplete-list-item",
                },
                [
                  _c(
                    "b-link",
                    {
                      staticClass:
                        "admin-companies-autocomplete-list-item-link",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return (() => _vm.setCompany(company)).apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [_vm._v("\n        " + _vm._s(company.name) + "\n      ")]
                  ),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }